import { render, staticRenderFns } from "./new_form.vue?vue&type=template&id=2a24563e&scoped=true&"
import script from "./new_form.vue?vue&type=script&lang=js&"
export * from "./new_form.vue?vue&type=script&lang=js&"
import style0 from "./new_form.vue?vue&type=style&index=0&id=2a24563e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24563e",
  null
  
)

export default component.exports